module.exports = __webpack_public_path__ + "media/images/front/about/bg_member-4e77606b4c34b065073b896f178da756.jpg";